<template>
  <v-container class="device-map" fluid>
    <snackBar></snackBar>
    <creationForm
      :orgId = "orgId"
      :location = "coordinates"
    ></creationForm>
    <coordinatesForm :dialog.sync="dialog" :coordinates.sync="stringyfiedCoords" @save="updateMap()"/>
    <markerWindow  :dialog.sync="dialog" :lat="fixCoordinates(coordinates.lat)" :lng="fixCoordinates(coordinates.lng)"></markerWindow>
    <v-img class="centered-marker" :src="icon"></v-img>
    <GmapMap
      ref="mapRef"
      :options="{
        zoomControl: false,
        scrollwheel: true,
        gestureHandling: 'greedy',
        draggable: true,
        scaleControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        MotionTrackingControl: true,

      }"
      :center="{lat:-38.001088, lng:-57.544016}"
      :zoom="zoom"
      class="gmap"
    >
    </GmapMap>
    <v-layout column class="fab-container">
      <div>
        <v-btn small dark fab color="white"
          @click="accessLocation()"
        >
          <v-icon medium color="black">gps_fixed</v-icon>
        </v-btn>
      </div>
      <div>
        <v-btn small dark fab color="white"
          @click="zoomControl(1)"
        >
          <v-icon large color="black">add</v-icon>
        </v-btn>
      </div>
      <div>
        <v-btn small dark fab color="white"
          @click="zoomControl(-1)"
        >
          <v-icon large color="black">remove</v-icon>
        </v-btn>
      </div>
    </v-layout>
  </v-container>
</template>

<script>

import {gmapApi} from 'vue2-google-maps';
const DeviceCreationForm = () => import('./DeviceCreationForm.vue');
const SnackBar = () => import('./DeviceCenterInputSnackbar.vue');
const CoordinatesInput = () => import('./CoordinatesInputForm.vue');
const MarkerWindow = () => import('./MarkerWindow.vue');

export default {
  name: 'google-map',
  data () {
    return {
      snackbar: true,
      dialog: false,
      icon: require(`../../../assets/icons/place2.png`),
      marker: null,
      coordinates: {
        lat: 0,
        lng: 0
      },
      infowindow: null,
      zoom: 11,
      map: null,
      mapName: this.name + '-map',
      loaded: false,
      orgId: this.$route.params.orgId
    };
  },
  computed: {
    google: gmapApi,
    stringyfiedCoords: {
      get: function () {
        const entries = Object.entries(this.coordinates);
        return `${this.fixCoordinates(entries[0][1])},${this.fixCoordinates(entries[1][1])}`;
      },
      set: function (value) {
        let coordinates = value.split(',');
        this.coordinates = {
          lat: this.fixCoordinates(parseFloat(coordinates[0])),
          lng: this.fixCoordinates(parseFloat(coordinates[1]))
        };
      }
    }
  },
  mounted () {
    const that = this;
    this.$refs.mapRef.$mapPromise.then((map) => {
      that.map = map;
      that.coordinates.lat = map.getCenter().lat();
      that.coordinates.lng = map.getCenter().lng();
      map.setMapTypeId('satellite');
      map.addListener('center_changed', function () {
        that.coordinates.lat = map.getCenter().lat();
        that.coordinates.lng = map.getCenter().lng();
      });
    });
  },
  beforeDestroy () {
  },
  created () {
  },
  methods: {
    fixCoordinates (value) {
      return parseFloat(value.toFixed(6));
    },
    zoomControl (variation) {
      this.zoom = parseInt(this.zoom) + variation;
      this.map.setZoom(this.zoom);
    },
    updateMap () {
      this.map.panTo(new this.google.maps.LatLng(this.coordinates));
    },
    accessLocation () {
      this.$getLocation({}).then((coordinates) => {
        this.coordinates = coordinates;
        this.map.panTo(coordinates);
      }).catch(error => console.log(error));
    }
  },
  components: {
    'creationForm': DeviceCreationForm,
    'snackBar': SnackBar,
    'coordinatesForm': CoordinatesInput,
    'markerWindow': MarkerWindow
  }
};
</script>


// WEBPACK FOOTER //
// DeviceCreationMap.vue?28506ba6